import { T } from "../themes";

// V28: Contextual first-use hint — shows once per feature per user
export default function FeatureHint({ id, text, onDismiss, position = "below" }) {
  if (!id || !text) return null;
  const isAbove = position === "above";
  return (
    <div style={{
      background: T.ink,
      border: `2px solid ${T.accent}`,
      boxShadow: T.shadow,
      padding: "10px 12px",
      borderRadius: T.radiusSm,
      marginTop: isAbove ? 0 : 6,
      marginBottom: isAbove ? 6 : 0,
      display: "flex",
      alignItems: "flex-start",
      gap: 8,
      position: "relative",
    }}>
      <span style={{ fontSize: 14, flexShrink: 0 }}>💡</span>
      <p style={{
        color: T.card,
        fontSize: 11,
        fontFamily: T.fontSans,
        fontWeight: "bold",
        margin: 0,
        lineHeight: 1.5,
        flex: 1,
      }}>{text}</p>
      <button onClick={onDismiss} style={{
        background: T.accent,
        border: "none",
        color: T.ink,
        fontSize: 9,
        fontFamily: T.fontSans,
        fontWeight: 900,
        padding: "4px 10px",
        cursor: "pointer",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        borderRadius: T.radiusXs,
        flexShrink: 0,
      }}>Got it</button>
    </div>
  );
}
